import { AppSettingCacheMixin } from '../Booking/AppSettingCacheMixin'

export const SiteGeneralRegistrationSettingMixin = {
  mixins: [AppSettingCacheMixin],
  computed: {
    settingKey () {
      return 'GeneralRegistration'
    },
    defaultSettingObject () {
      return {
        clientRegistrationEnabled: false
      }
    }
  }
}
